import classNames from "classnames";

import UptimeMascot from "@/assets/images/uptime-logo-slack.svg";
import {AssistantIconProps} from "@/components/assistant/AssistantIcon.types.ts";

import styles from "./AssistantIcon.module.scss";

export const AssistantIcon = ({size = "medium", className}: AssistantIconProps) => (
  <div className={classNames(styles.assistantIcon, styles[size], className)}>
    <img src={UptimeMascot} alt="" />
  </div>
);
